import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"#F5F5F5","overflow":"hidden"} }
const _hoisted_2 = { class: "copyright comBox" }
const _hoisted_3 = { class: "newTrialMaterial_box" }
const _hoisted_4 = { style: {"display":"flex","justify-content":"flex-start"} }
const _hoisted_5 = {
  key: 0,
  style: {"color":"#4BC185","background":"#4BC18520","padding":"0.02rem 0.04rem","box-sizing":"border-box","border-radius":"0.04rem"}
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"#F53F3F","background":"#F53F3F20","padding":"0.02rem 0.04rem","box-sizing":"border-box","border-radius":"0.04rem"}
}
const _hoisted_7 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_8 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_9 = { style: {"display":"flex","justify-content":"center","margin-bottom":"0.23rem"} }

import { ref } from 'vue'
	import type { TabsPaneContext } from 'element-plus'
	import { ElTable } from 'element-plus'

	interface User {
		date : string
		name : string
		address : string
		katype : string
		pirce : string,
		number : number,
	}

	
export default /*@__PURE__*/_defineComponent({
  __name: 'copyrightPage',
  setup(__props) {

	const activeName = ref('first');

	const searchValue = ref('');

	const activeList = ref([
		{
			label: '版权存证',
			name: 'first',
			satus: 1,
		}, {
			label: '著作权登记',
			name: 'second',
			satus: 2,
		}
	])
	const handleClick = (tab : TabsPaneContext, event : Event) => {
		console.log(tab, event)
	}

	// 表格
	const allCheckbox = ref(false)

	const multipleTableRef = ref<InstanceType<typeof ElTable>>()
	const multipleSelection = ref<User[]>([])
	const toggleSelection = (rows ?: User[]) => {
		if (rows) {
			rows.forEach((row) => {
				multipleTableRef.value!.toggleRowSelection(row, undefined)
			})
		} else {
			multipleTableRef.value!.clearSelection()
		}
	}
	const handleSelectionChange = (val : User[]) => {
		multipleSelection.value = val
	}
	var data = [];  // 创建一个空数组

	for (var i = 0; i < 10; i++) {
		data.push({
			id: '45648941615641',
			name: '手绘青海风景动态大屏',
			pirce: '￥500.00',
			type: '联合信任时间戳服务中心',
			time: '2023-06-08 15:14',
			katype: '未开票',
			faid: '/',
			number: 34
		});  // 将相同的数据添加到数组中
	}
	const tableData : User[] = data;

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"height":"0.08rem"} }, null, -1)),
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
          class: "demo-tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                label: item.label,
                name: item.name,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_input, {
                        style: {"width":"300px"},
                        modelValue: searchValue.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
                        placeholder: "输入作品名称、编号进行搜索"
                      }, null, 8, ["modelValue"]),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "searchBtn" }, "搜索", -1))
                    ])
                  ]),
                  _createVNode(_unref(ElTable), {
                    ref_for: true,
                    ref_key: "multipleTableRef",
                    ref: multipleTableRef,
                    data: _unref(tableData),
                    style: {"width":"100%"},
                    height: "650"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        property: "id",
                        label: "作品编号",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "name",
                        label: "作品名称 ",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "type",
                        label: "存证渠道",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "time",
                        label: "提交时间",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "name",
                        label: "存证状态",
                        align: "center"
                      }, {
                        default: _withCtx((scope) => [
                          (scope.$index != 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 已存证 "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, " 存证失败 "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "操作",
                        width: "190",
                        align: "center"
                      }, {
                        default: _withCtx((scope) => [
                          (scope.$index == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[3] || (_cache[3] = [
                                _createElementVNode("div", { style: {"color":"#3FA4ED","margin-left":"0.1rem","line-height":"0.43rem"} }, "重新存证", -1)
                              ])))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[4] || (_cache[4] = [
                                _createElementVNode("div", { style: {"color":"#3FA4ED","margin-left":"0.1rem","line-height":"0.43rem"} }, "下载证书", -1),
                                _createElementVNode("div", { style: {"color":"#3FA4ED","margin-left":"0.1rem","line-height":"0.43rem"} }, "查看作品", -1)
                              ])))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: 1000
      })
    ])
  ]))
}
}

})